// Public company details, as published on https://www.sensemode.biz/contact (captured October 2026).
export const company = {
  legalName: 'סנס-מוד בע"מ',
  address: "משה שפירא 5, נתניה",
  phoneLabel: "שיווק ומכירות",
  phoneDisplay: "050-3427375",
  phoneHref: "tel:+972503427375",
  email: "itai@sensemode.com",
} as const;
